import React, { useRef, useCallback } from 'react'

import classnames from 'classnames/bind'

import { Title } from 'components/typo'
import Image from 'components/shared/Image'

import useLabelTitleTextAnimation from 'hooks/useLabelTitleTextAnimation'
import useResizeIndex from 'hooks/useResizeIndex'
import useAnimateInView from 'hooks/useAnimateInView'
import useComponentSize from '@rehooks/component-size'
import headlineRightImage from './headline-right.svg'
import headlineLeftImage from './headline-left.svg'
import css from './styles.module.scss'

const cx = classnames.bind(css)

const HeadlineArt = ({ title, darkMode, layout }) => {
  const componentRef = useRef()
  const elementRef = useRef()
  const headlineRef = useRef()
  const { width, height } = useComponentSize(componentRef)
  const resizeIndex = useResizeIndex()

  const tl = useLabelTitleTextAnimation(
    {
      elementRef,
      components: [
        {
          key: 'headline',
          ref: headlineRef,
          type: 'splitText',
        },
      ],
      linesClass: css.line,
    },
    [width, height, resizeIndex]
  )

  const [inViewRef] = useAnimateInView(
    {
      triggerOnce: true,
      ref: componentRef,
      animateIn: () => tl.restart(true),
    },
    [width, height, resizeIndex]
  )

  const setRef = useCallback((node) => {
    elementRef.current = node
    inViewRef(node)
  }, [])
  
return (
    title && (
      <div ref={componentRef}>
        <div
          ref={setRef}
          className={cx(css.TitleWrapper, layout, { darkMode })}
        >
          <div ref={headlineRef}>
            <Title className={css.title} theme={darkMode ? 'white' : 'dark'}>
              {title}
            </Title>
          </div>
          {/* {layout === 'left' && (
            <Image
              src={headlineLeftImage}
              className={cx(css.image, css.left)}
              media={{ width: 144, height: 115 }}
            />
          )}
          {layout === 'right' && (
            <Image
              src={headlineRightImage}
              className={cx(css.image, css.right)}
              media={{ width: 144, height: 115 }}
            />
          )} */}
        </div>
      </div>
    )
  )
}

HeadlineArt.defaultProps = {
  darkMode: true,
  layout: 'left',
}

export default HeadlineArt
